import React from 'react';
import bannerBg from '../assets/img/page-banner.webp';
/*import ContactForm from '../components/ContactForm';*/
import ContactUs from '../components/ContactUs';
import PageBanner from '../components/PageBanner';
import Footer2 from '../components/Footer2';
import Header3 from '../components/Header3';

function Contact() {
    return (
        <>
            <Header3 />
            <PageBanner bannerBg={bannerBg} heading="Contact Us" currentPage="Contact" />
            <ContactUs />
            {/* <ContactForm title="Write Message" heading="Get In Touch" /> */}
            <Footer2 />
        </>
    );
}

export default Contact;
